// Shared component styles. Preserve selector order, style values, and caller overrides.
import { createToolbarSelectSx } from "./toolbarControlStyles";
import { TAB_VIEW_HEADER_TOP_PADDING, TAB_VIEW_SIDE_PADDING_X } from "./tabViewContentSpacing";
export const BLUE = "#3451F4";
export const PURPLE = "#9C4FFF";
export const TEXT = "#000000";
export const MUTED = "#A2ABB4";
export const BORDER = "#D2D8DE";
export const actionSelectSx = createToolbarSelectSx({
  height: 34,
  borderRadius: 4,
  backgroundColor: "#FFFFFF",
  textColor: TEXT,
  textFontSize: 14,
  textFontWeight: 400,
  outlineSx: {
    borderTop: `1px solid ${BORDER}`,
    borderRight: `1px solid ${BORDER}`,
    borderLeft: `1px solid ${BORDER}`,
    borderBottom: "none",
    borderRadius: "4px 4px 0 0"
  }
});
export const profileHeaderStyles = {
  root: ({
    sx
  }) => ({
    mx: 0,
    px: TAB_VIEW_SIDE_PADDING_X,
    pt: TAB_VIEW_HEADER_TOP_PADDING,
    background: "#fff",
    width: "100%",
    minWidth: 0,
    ...sx
  }),
  titleRow: () => ({
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      md: "1fr auto"
    },
    columnGap: 2,
    rowGap: 1,
    alignItems: "flex-start"
  }),
  title: () => ({
    color: BLUE,
    fontWeight: 700,
    fontSize: 20,
    lineHeight: "30px",
    mb: 0,
    minWidth: 0,
    overflowWrap: "anywhere"
  }),
  metadata: () => ({
    display: "flex",
    alignItems: "center",
    justifyContent: {
      xs: "flex-start",
      md: "flex-end"
    },
    flexWrap: "wrap",
    gap: 1,
    minWidth: 0,
    minHeight: 24
  }),
  metadataLabel: () => ({
    fontSize: 14,
    color: TEXT,
    fontWeight: 400
  }),
  metadataValue: ({
    onMetaValueClick
  }) => ({
    fontSize: 14,
    color: PURPLE,
    fontWeight: 400,
    ...(onMetaValueClick ? {
      border: 0,
      p: 0,
      background: "transparent",
      cursor: "pointer",
      textDecoration: "underline",
      textUnderlineOffset: "2px"
    } : null)
  }),
  dateDivider: () => ({
    fontSize: 14,
    color: MUTED,
    fontWeight: 400
  }),
  dateText: () => ({
    fontSize: 14,
    color: MUTED,
    fontWeight: 400
  }),
  tabRow: () => ({
    mt: 2,
    position: "relative",
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      md: "1fr auto"
    },
    columnGap: 2,
    rowGap: 1.5,
    alignItems: {
      xs: "stretch",
      md: "end"
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: "1px",
      backgroundColor: BORDER,
      zIndex: 2,
      pointerEvents: "none"
    }
  }),
  tabWrapper: () => ({
    minWidth: 0,
    maxWidth: "100%",
    position: "relative",
    mb: 0,
    zIndex: 3
  }),
  tabLabel: () => ({
    color: "inherit"
  }),
  tabCount: () => ({
    fontSize: 12,
    lineHeight: "18px",
    height: 22,
    px: 1,
    backgroundColor: "#FAFAFA",
    color: "#A2ABB4"
  }),
  tabs: () => ({
    pt: 0,
    minHeight: 40,
    "& .MuiTab-root": {
      padding: 0,
      minHeight: 40,
      color: PURPLE
    }
  }),
  actionWrapper: () => ({
    position: "relative",
    zIndex: 1,
    display: "flex",
    justifyContent: {
      xs: "stretch",
      md: "flex-end"
    },
    alignItems: {
      xs: "stretch",
      md: "center"
    },
    flexWrap: "wrap",
    gap: 1,
    minWidth: 0,
    width: {
      xs: "100%",
      md: "auto"
    },
    pb: 0
  }),
  actionLabel: () => ({
    fontSize: 14,
    color: TEXT,
    fontWeight: 400,
    whiteSpace: "nowrap",
    alignSelf: "center"
  }),
  actionAnchor: () => ({
    width: {
      xs: "100%",
      sm: "auto"
    },
    minWidth: 0
  }),
  actionSelect: ({
    actionSx
  }) => ({
    width: {
      xs: "100%",
      sm: "auto"
    },
    minWidth: {
      xs: 0,
      sm: 170
    },
    ...actionSelectSx,
    ...actionSx,
    "& .MuiSelect-select": {
      ...actionSelectSx["& .MuiSelect-select"],
      ...actionSx["& .MuiSelect-select"]
    }
  }),
  actionMenu: ({
    actionAnchorRef
  }) => ({
    mt: 0.5,
    minWidth: actionAnchorRef.current?.offsetWidth || 170,
    border: `1px solid ${BORDER}`,
    borderRadius: "4px",
    boxShadow: "0 12px 24px rgba(15, 23, 42, 0.08)",
    overflow: "hidden",
    "& .MuiMenuItem-root": {
      minHeight: 30,
      px: 1.5,
      fontSize: 14,
      fontWeight: 400,
      color: TEXT,
      borderBottom: `1px solid ${BORDER}`
    },
    "& .MuiMenuItem-root:last-of-type": {
      borderBottom: "none"
    }
  }),
  placeholder: () => ({
    color: MUTED,
    fontWeight: 400
  }),
  placeholderOption: () => ({
    fontWeight: 400,
    fontStyle: "normal"
  }),
  menuOption: ({
    option
  }) => ({
    fontWeight: 400,
    ...option.sx
  }),
  feedbackPopper: () => ({
    zIndex: theme => theme.zIndex.snackbar
  }),
  feedbackAlert: () => ({
    width: "max-content",
    maxWidth: 320,
    boxShadow: "0 14px 32px rgba(15,23,42,0.16)",
    "& .MuiAlert-message": {
      fontSize: 12,
      lineHeight: 1.35
    }
  }),
  emptyAction: () => ({
    minWidth: 0,
    width: {
      xs: "100%",
      md: 260
    }
  }),
  summary: () => ({
    pt: 3.5
  })
};
